import React, { useEffect, useState } from "react";
import { Form, Dropdown, Input, Button } from "semantic-ui-react";
import { pb4y as api, producaov2 } from "../../../../../../services/apis";
import { isAuthAdmin } from "../../../../../../services/auth";
import * as yup from "yup";

import swal from "sweetalert";

import { Link } from "react-router-dom";
import { Label } from "../../Criar/Formulario/styles";

const Formulario = ({ props }) => {
  const [cupom, setCupom] = useState({
    cupom: "",
    ativo: 1,
    usado: 0,
    max_uso: 6000,
    tempo_validade: "+12 months",
    isParceiro: 0,
  });

  const { id } = props.match.params;

  useEffect(() => {
    loadAuth();
    api
      .get(`/admin/cupons/${id}`, {headers: {access_token: `voitto-token ${localStorage.getItem("oauth_token")}`}})
      .then((res) => setCupom(res.data))
      .catch((err) => {
        swal("Não foi possível pegar o cupom", err, "");
        props.history.push("/admin/pocketbook/cupons");
      });
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const update = async () => {
    const cupomValidation = await yup.object().shape({
      cupom: yup
        .string("Necessário que informe o nome do cupom")
        .required("Necessário que informe o nome do cupom"),
      ativo: yup
        .number("Necessário que informe a url do cupom")
        .required("Necessário que informe a url do cupom"),
      usado: yup
        .number("Necessário que informe a url do cupom")
        .required("Necessário que informe a url do cupom"),
      max_uso: yup
        .number("Necessário que informe a url do cupom")
        .required("Necessário que informe a url do cupom"),
      tempo_validade: yup
        .string("Necessário que informe o tempo de validade do cupom")
        .required("Necessário que informe a url do cupom"),
      isParceiro: yup
        .number("Necessário que informe a url do cupom")
        .required("Necessário que informe a url do cupom"),
    });

    try {
      await cupomValidation.validate(cupom, { abortEarly: true });
      api
        .put(`/admin/cupons/${id}`, cupom, {headers: {access_token: `voitto-token ${localStorage.getItem("oauth_token")}`}})
        .then((res) => {
          let logs = {
            local: "PocketBook",
            texto: `editou o cupom de id=${id}`,
          };
          producaov2.post("system_logs", { acao: JSON.stringify(logs) });
          props.history.push("/admin/pocketbook/cupons");
        })
        .catch((err) => {
          swal("Não foi possível salvar o cupom", err, "");
        });
    } catch (err) {
      if (err instanceof yup.ValidationError) {
        swal("Erro!", `${err}`, "error");
        return;
      }
    }
  };

  return (
    <Form>
      <Form.Group widths="equal">
        <Form.Field
          control={Input}
          label="Cupom"
          placeholder="Cupom"
          value={cupom.cupom}
          onChange={(e) => {
            setCupom({ ...cupom, cupom: e.target.value });
          }}
        />
      </Form.Group>

      <Form.Group widths="equal">
        <Form.Field
          control={Input}
          label="Ativo"
          placeholder="Ativo"
          type="number"
          value={cupom.ativo}
          onChange={(e) => {
            e.target.value > 0
              ? setCupom({ ...cupom, ativo: 1 })
              : setCupom({ ...cupom, ativo: 0 });
          }}
        />
      </Form.Group>

      <Form.Group widths="equal">
        <Form.Field
          control={Input}
          label="Usado"
          placeholder="Usado"
          type="number"
          value={cupom.usado}
          onChange={(e) => {
            e.target.value > 0
              ? setCupom({ ...cupom, usado: 1 })
              : setCupom({ ...cupom, usado: 0 });
          }}
        />
      </Form.Group>

      <Form.Group widths="equal">
        <Form.Field
          control={Input}
          label="Uso máximo"
          placeholder="Uso máximo"
          type="number"
          value={cupom.max_uso}
          onChange={(e) => {
            setCupom({ ...cupom, max_uso: e.target.value });
          }}
        />
      </Form.Group>

      <Label>Validade</Label>
      <Dropdown
        name="validade"
        label="Validade"
        search
        placeholder="Adicione um tempo"
        fluid
        selection
        value={cupom.tempo_validade}
        options={[
          { key: "+12 months", value: "+12 months", text: "+12 months" },
          { key: "+6 months", value: "+6 months", text: "+6 months" },
        ]}
        onChange={(e, { value }) =>
          setCupom({ ...cupom, tempo_validade: value })
        }
      />

      <Form.Group widths="equal">
        <Form.Field
          control={Input}
          label="Parceiro"
          placeholder="Parceiro"
          type="number"
          value={cupom.isParceiro}
          onChange={(e) => {
            e.target.value > 0
              ? setCupom({ ...cupom, isParceiro: 1 })
              : setCupom({ ...cupom, isParceiro: 0 });
          }}
        />
      </Form.Group>

      <Form.Group>
        <Form.Field control={Button} onClick={() => update()}>
          Atualizar
        </Form.Field>
        <Link to="/admin/pocketbook/cupons">
          <Button color="secondary">Cancelar</Button>
        </Link>
      </Form.Group>
    </Form>
  );
};

export default Formulario;
